const ThingActionState = Object.freeze({
  Pending: 'pending',
  Running: 'running',
  Canceled: 'canceled',
  Error: 'error',
  Finished: 'finished'
})

export default ThingActionState



// WEBPACK FOOTER //
// ./src/constants/thing_action_state.js